import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { SideNavDirection } from './side-nav-direction';
import { SignPdfService } from '../../sign-pdf.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SideNavComponent implements OnInit {

  showSideNav:any;

  @Input() sidenavTemplateRef: any;
  @Input() duration: number = 0.25;
  @Input() navWidth: number = window.innerWidth;
  @Input() direction: any = SideNavDirection.Left;
  
  constructor(private signPdfService: SignPdfService){}

  ngOnInit(): void {
    this.showSideNav = this.signPdfService.getShowNav();
    this.onSidebarOpen();
  }

  onSidebarClose() {
    this.signPdfService.setShowNav(false);
  }
  onSidebarOpen() {
    this.signPdfService.setShowNav(true);
  }

  getSideNavBarStyle(showNav: any) {
    let navBarStyle: any = {};
    
    // navBarStyle.transition = this.direction + ' ' + this.duration + 's, visibility ' + this.duration + 's';
    navBarStyle.width = this.navWidth + 'px';
    navBarStyle[this.direction] = (showNav ? 0 : (this.navWidth * -1)) + 'px';
    
    return navBarStyle;
  }
}
